"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Plottable = _interopRequireWildcard(require("plottable"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Helper for loading new data into a Plottable plot.
 */
var setXYPlotDataFactory = function setXYPlotDataFactory(plot) {
  return function (_ref) {
    var data = _ref.data,
      series = _ref.series,
      activeSeriesIndexSet = _ref.activeSeriesIndexSet,
      focusedSeries = _ref.focusedSeries;
    var datasets = series.map(function (s, index) {
      return new Plottable.Dataset(data, _objectSpread(_objectSpread({}, s), {}, {
        isFocused: index === focusedSeries,
        isHidden: activeSeriesIndexSet && !activeSeriesIndexSet.has(index)
      }));
    }).filter(function (dataset) {
      return !dataset.metadata().isHidden;
    });

    // check if focusedSeries is set to move focused element to the end of the array
    if (plot instanceof Plottable.Plots.Line && (focusedSeries || focusedSeries === 0)) {
      datasets.sort(function (d1, d2) {
        if (d1.metadata().isFocused) {
          return 1;
        }
        if (d2.metadata().isFocused) {
          return -1;
        }
        return 0;
      });
    }
    plot.datasets(datasets);
  };
};
var _default = exports["default"] = setXYPlotDataFactory;
//# sourceMappingURL=setXYPlotDataFactory.js.map